import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-cards.css';

var getClassNameList = classNames.bind(styles);
var UitkCardLink = function (props) {
    var children = props.children;
    var childrenArray = React.Children.toArray(children);
    var firstChild = childrenArray[0];
    var decoratedFirstChild = React.cloneElement(firstChild, {
        className: getClassNameList(firstChild.props.className, 'uitk-card-link')
    }, React.createElement("span", { className: "is-visually-hidden" }, firstChild.props.children));
    if (!childrenArray || childrenArray.length !== 1) {
        console.warn("UitkCardLink uses the first child element. ".concat(childrenArray.length, " children found."));
    }
    return decoratedFirstChild;
};
UitkCardLink.displayName = 'UitkCardLink';
// Temporary, unstable
var UitkCardAlohaLink = UitkCardLink;

export { UitkCardAlohaLink, UitkCardLink };
